import React, {useEffect, useState} from "react";
import Header from "../../components/Header";
import OrderIdle from "../../components/OrderIdle";
import "./style.scss";
import {useParams} from "react-router";
import Addons from "../../components/Addons";
import {MenuItem} from "../../@types/stores/menu";
import menuStore from "../../stores/menu";
import orderStore from "../../stores/order";
import {v4 as guid} from "uuid";

const HalfAndHalfAddonPage = () => {
    let params = useParams()

    const [item, setItem] = useState<MenuItem>();

    useEffect(() => {
        getItem(params.articleNumber);
    }, [params.articleNumber]);

    const getItem = async (number: string | undefined) => {
        // Menu article
        if (typeof params.categoryId !== "undefined") {
            if (!menuStore.menu) {
                await menuStore.getMenu();

                const category = params.categoryId ? +params.categoryId : 0;
                menuStore.changeCategory(category);

                const subCategory = params.subCategoryId ? +params.subCategoryId : 0;
                menuStore.changeSubCategory(subCategory);
            }

            if (number) {
                const _item = menuStore.getItemByNumber(number);
                if (_item) {
                    setItem(_item);
                    menuStore.changeMenuItem(_item.id);

                    if (!orderStore.currentOrderLine) {
                        orderStore.setCurrentOrderLine = {
                            id: guid(),
                            menuId: menuStore.navigation.category,
                            subMenuId: menuStore.navigation.subCategory,
                            name: _item.name,
                            number: _item.number,
                            count: 0.5,
                            price: _item.price,
                            total: _item.price,
                            img: _item.previewList,
                            sellUnitId: menuStore.selectedAdditionalSellUnitHalfAndHalf?.sellUnitId || undefined,
                            sellFactor: menuStore.selectedAdditionalSellUnitHalfAndHalf?.sellFactor || undefined
                        };
                    }
                }
            }
        }
    }

    if (!item) return null;

    return <div className="HalfAndHalfAddonPage">
        <Header />
        <Addons item={item} skipRecommendations={false} isHalfAndHalf={true} />
        <OrderIdle />
    </div>
}

export default HalfAndHalfAddonPage;
